<template>
  <div>
    <div class="w-full bg-h-primary-800 px-8">
      <div class="grid grid-cols-12 md:p-8 py-8 gap-y-10 gap-3">
        <div
          class="col-span-12 sm:col-span-12 lg:col-span-6 xl:col-span-6 text-center md:text-start"
        >
          <h5 class="text-white  font-bold">
            {{
              $t("labels.generic", {
                pt: "Sistema Homero",
                en: "Homero System",
              })
            }}
          </h5>
          <p class="text-white text-[12px]">
            {{
              $t("labels.generic", {
                pt: "Plataforma de educação adaptativa, com uso de inteligência artificial, na qual os alunos capacitam-se, conforme a sua disponibilidade e condições de aprendizado.",
                en: "Adaptive education platform, using artificial intelligence, in which students are trained, according to their availability and learning conditions.",
              })
            }}
          </p>
        </div>
        <div
          class="col-span-12 sm:col-span-12 lg:col-span-6 xl:col-span-6 flex justify-around px-4 mt-2 gap-8 md:gap-3 scale-[0.6] md:scale-100 w-100 h-6 sm:h-6 lg:h-6 xl:h-10"
        >
          <img src="@/assets/images/uece-white.svg" alt="uece" />
          <img src="@/assets/images/mcti-white.svg" alt="mcti" />
          <img src="@/assets/images/softex-white.svg" alt="softex" />
          <img src="@/assets/images/irede-white.svg" alt="irede" />
        </div>
      </div>
      <div class="flex w-full justify-center items-center mt-14 lg:mt-10">
        <p class="text-white py-5 text-sm">
          © {{ todayYear }}.
          {{
            $t("labels.generic", {
              pt: "Todos os direitos reservados.",
              en: "All rights reserved.",
            })
          }}
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "footerComponent",
  computed: {
    todayYear(): number {
      let today = new Date();
      return today.getFullYear();
    },
  },
});
</script>

